import { createApp } from 'vue';
import App from './App.vue';
import axiosPlugin from './plugins/axios';
import router from './router';
import store from './store';
import PortalVue from 'portal-vue';
import VueScrollTo from 'vue-scrollto';
import { plugin as VueInputAutowidth } from 'vue-input-autowidth';

// import style from '@speechki-frontend/shared/assets/scss/common.scss';

import i18n from '@speechki-frontend/core/i18n/i18n';

// @todo consider this, probably not the best way to share plugins
import tooltip from '@speechki-frontend/shared/helpers/plugins/tooltip';

// global components @todo find a one place to share globals
import Spinner from '@speechki-frontend/shared/ui/Spinner';

// Sentry
import initSentry from '@speechki-frontend/shared/helpers/plugins/sentry';

const app = createApp(App);

app.component('Spinner', Spinner);

app.use(axiosPlugin);
app.use(i18n);
app.use(router);
app.use(store);
app.use(PortalVue);
app.use(VueScrollTo);
app.use(VueInputAutowidth);
app.use(tooltip);

app.config.globalProperties.$isManageApp = true;
app.config.globalProperties.$isClientApp = false;
app.config.globalProperties.$isCrmApp = false;

initSentry(app);

app.mount('#app');
